<div class="d-flex flex-column min-vh-100 app-layout p-0 m-0">

  <div class="flex-grow-1 d-flex overflow-hidden app-content no-header">

    @if(user){
    <aside class="side-nav-wrapper">
      <app-side-navigation></app-side-navigation>
    </aside>
    }
    <div class="d-flex flex-column flex-grow-1 overflow-hidden">
      @if(user) {
      <header class="position-sticky top-0 z-3 bg-white ">
        <app-header (toggleHistoryEvent)="onToggleHistory()"></app-header>
      </header>
      }
      <div class="d-flex flex-grow-1 overflow-hidden position-relative">
        <main class="flex-grow-1 overflow-auto" [class.overflow-x-hidden]="hideHeader" #mainContent>
          <!-- <app-breadcrumb></app-breadcrumb> -->
          <router-outlet></router-outlet>
        </main>
        
        <!-- Global History Sidebar -->
        @if(showHistory) {
        <aside class="chat-history-sidebar border-start d-flex flex-column bg-white h-100 flex-shrink-0 shadow-sm animate-fade-in" style="width: 300px; z-index: 1040;">
          <div class="history-header p-4 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
            <h6 class="fw-bold mb-0 text-dark" style="font-size: 1.1rem;">History</h6>
            <i class="bi bi-x-lg text-secondary" style="font-size: 1rem; cursor: pointer;" (click)="showHistory = false"></i>
          </div>
          <div class="history-list-wrapper flex-grow-1 overflow-auto p-3 custom-scrollbar">
            <div class="history-section mb-4">
              <label class="history-divider-label text-uppercase text-muted fw-bold mb-3 d-block" style="font-size: 11px; letter-spacing: 0.05em;">HISTORY</label>
              @for(item of chatHistory; track $index) {
              <div class="history-card p-3 rounded-3 mb-2 hover-bg" role="button" (click)="selectHistoryItem(item)" style="cursor: pointer;">
                <div class="h-title fw-semibold text-dark mb-1" style="font-size: 0.95rem;">{{ item.question }}</div>
                @if($index === 0) {
                <div class="h-time text-muted small" style="font-size: 0.75rem;">Recently</div>
                }
              </div>
              }
            </div>
          </div>
        </aside>
        }
      </div>

      @if (user) {
      <footer class="d-none d-lg-block z-3 bg-white shadow-sm border-top">
        <app-footer></app-footer>
      </footer>
      }
    </div>
  </div>
</div>